import isNil from 'lodash/isNil';
import {MRT_ColumnDef} from 'material-react-table';

import {EventLink} from '@entities/event';
import {UserLink} from '@entities/user';
import {CurrencyValue, rightAlignmentColumnProps} from '@shared/components';
import {DATETIME_FORMAT} from '@shared/constants';
import {formatInTz} from '@shared/utils';
import {Stake} from '../types';

const EMPTY_VALUE = '—';

const localAmount = (value: number, currency: string) => (
  <CurrencyValue value={value} prefix="" suffix={` ${currency}`} />
);

const amountCell = (value: number | null) =>
  isNil(value) ? EMPTY_VALUE : <CurrencyValue value={value} />;

export const stakeColumns: MRT_ColumnDef<Stake>[] = [
  {
    accessorKey: 'id',
    header: 'ID',
    Cell: ({row}) => row.original.id.slice(0, 8),
    size: 120,
  },
  {
    accessorKey: 'created',
    header: 'Created',
    Cell: ({row}) => formatInTz(row.original.created, DATETIME_FORMAT),
    size: 160,
  },
  {
    accessorKey: 'userId',
    header: 'User',
    Cell: ({row}) => <UserLink userId={row.original.userId} />,
    size: 120,
  },
  {
    accessorKey: 'eventSlug',
    header: 'Event',
    Cell: ({row}) => <EventLink eventId={row.original.eventSlug} />,
    size: 140,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 120,
  },
  {
    accessorKey: 'real',
    header: 'Real',
    Cell: ({row}) => amountCell(row.original.real),
    size: 120,
    ...rightAlignmentColumnProps,
  },
  {
    accessorKey: 'promo',
    header: 'Promo',
    Cell: ({row}) => amountCell(row.original.promo),
    size: 120,
    ...rightAlignmentColumnProps,
  },
  {
    accessorKey: 'localAmount',
    header: 'Local amount',
    Cell: ({row}) =>
      localAmount(row.original.localAmount, row.original.currency),
    size: 150,
    ...rightAlignmentColumnProps,
  },
  {
    accessorKey: 'payoutReal',
    header: 'Payout real',
    Cell: ({row}) => amountCell(row.original.payoutReal),
    size: 140,
    ...rightAlignmentColumnProps,
  },
  {
    accessorKey: 'payoutPromo',
    header: 'Payout promo',
    Cell: ({row}) => amountCell(row.original.payoutPromo),
    size: 140,
    ...rightAlignmentColumnProps,
  },
];
